import styled, { css } from 'styled-components';
import { device } from '@/styles/helpers';

export const ScEmblaPagination = styled.div<{ $compact?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 40px 28px;
  position: absolute;
  inset: auto auto 0 0;
  width: 100%;
  z-index: 1;

  @media (${device.mobile}) {
    padding: 12px 40px 36px;
  }

  ${({ $compact }) =>
    $compact &&
    css`
      position: static;
      inset: auto;
      padding: 8px 0 0;
      gap: 8px;

      @media (${device.mobile}) {
        padding: 0;
      }
    `}

  button.pagination-bullet {
    width: 100%;
    max-width: 48px;
    padding: 4px;
    cursor: pointer;
    background: transparent;
    border: none;
    outline: none;

    @media (${device.mobile}) {
      max-width: 80px;
    }

    ${({ $compact }) =>
      $compact &&
      css`
        max-width: 40px;
        padding: 0;

        @media (${device.mobile}) {
          max-width: 40px;
        }
      `}

    &:before {
      position: relative;
      content: "";
      width: 100%;
      height: 4px;
      display: block;
      background: ${({ theme }) => theme.whiteColor};
      opacity: 0.2;
      border-radius: 20px;
      transition: 0.2s;
    }

    &:hover:before {
      opacity: 0.3;
    }

    &.active:before,
    &.active:hover:before {
      opacity: 1;
    }
  }
`;

export const ScEmblaArrows = styled.div`
  .embla__arrow {
    position: absolute;
    display: block;
    border: none;
    background: none;
    padding: 2px;
    z-index: 2;
    width: 16px;
    height: 40px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    transition: all 0.3s ease 0s;
    opacity: 1;

    &:before,
    &:after {
      content: '';
      display: block;
      width: 24px;
      height: 1px;
      background-color: ${({ theme }) => theme.whiteColor};
      position: absolute;
      left: -4px;
      transition: all 0.3s ease 0s;
    }

    &.prev {
      left: 0;

      &:before {
        top: 30px;
        transform: rotate(50deg);
      }

      &:after {
        top: 12px;
        transform: rotate(-50deg);
      }

      @media (hover: hover) {
        &:hover:before {
          transform: scale(1.2) rotate(65deg);
          top: 34px;
        }

        &:hover:after {
          transform: scale(1.2) rotate(-65deg);
          top: 8px;
        }
      }
    }

    &.next {
      right: 0;

      &:before {
        top: 30px;
        transform: rotate(-50deg);
      }

      &:after {
        top: 12px;
        transform: rotate(50deg);
      }

      @media (hover: hover) {
        &:hover:before {
          transform: scale(1.2) rotate(-65deg);
          top: 34px;
        }

        &:hover:after {
          transform: scale(1.2) rotate(65deg);
          top: 8px;
        }
      }
    }

    &:disabled {
      opacity: 0.2;
      cursor: default;
    }
  }
`;
